import React, { useEffect, useState } from 'react';
import {
  NavigationType,
  useLocation,
  useNavigate,
  useNavigationType,
} from 'react-router-dom';

import HistoryContext from 'contexts/historyContext';

export default function HistoryProvider(props: {
  children: JSX.Element;
}): JSX.Element {
  const { pathname, state, search, hash } = useLocation();
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const currentUri = `${pathname}${search}${hash}`;
  const [previousPath, setPreviousPath] = useState(currentUri);
  const isReady =
    !!state?.historyPreviousPath || navigationType !== NavigationType.Push;

  useEffect(() => {
    switch (navigationType) {
      case NavigationType.Push:
        setPreviousPath(currentUri);
        navigate(currentUri, {
          replace: true,
          state: {
            ...state,
            historyPreviousPath: previousPath,
          },
        });
        break;
      case NavigationType.Pop:
        setPreviousPath(currentUri);
    }
  }, [currentUri, state, navigationType]);

  return (
    <HistoryContext.Provider
      value={{
        previousPath: state?.historyPreviousPath,
        previousPage: state?.historyPreviousPage,
        changeColorCounter: state?.historyChangeColorCounter ?? 0,
        isLoaded: isReady,
      }}
    >
      {props.children}
    </HistoryContext.Provider>
  );
}
